import { render, staticRenderFns } from "./quickMatch.vue?vue&type=template&id=874d0a1e&scoped=true&"
import script from "./quickMatch.vue?vue&type=script&lang=js&"
export * from "./quickMatch.vue?vue&type=script&lang=js&"
import style0 from "./quickMatch.vue?vue&type=style&index=0&id=874d0a1e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874d0a1e",
  null
  
)

export default component.exports